/**
 * Generates the storage path for a study image
 * @param moduleId - The module ID
 * @param topic - The topic name
 * @param filename - The filename (should include extension)
 * @returns The storage path for the study image
 */
export default function getStudyImagePath(moduleId: string, topic: string, filename: string): string {
  return `studies/${moduleId}/${topic}/${filename}`;
}
